import Skeleton from "react-loading-skeleton";
import { ErrorMessage, ErrorMessageWrapper } from "../../../components/messages";
import { InfoBubbleNotesWrapper } from "../components";
import useRiskFactors from "../hooks/useRiskFactors";

const RiskFactorsSection = () => {
    const { section, isLoading, error, isError, updateRiskFactorNotes, refetch } = useRiskFactors();
    const { assessmentOfKnowledge, understandingRiskAndReward, capacityForLoss, risksOfPensionDrawdown } = section || {};

    if (error || isError) {
        return <ErrorMessageWrapper>
            <ErrorMessage error={error} retryCallback={refetch} />
        </ErrorMessageWrapper>
    }

    return <div className="container-fluid">
        <div className="row mb-4">
            {isLoading
                ? <Skeleton />
                : <InfoBubbleNotesWrapper
                    label={"Assessment of Knowledge and Experience:"}
                    fieldKey={"assessmentOfKnowledge"}
                    defaultValue={assessmentOfKnowledge?.notes}
                    onBlur={(newValue) => updateRiskFactorNotes(assessmentOfKnowledge.notesId, newValue)}
                />}
        </div>
        <div className="row mb-4">
            {isLoading
                ? <Skeleton />
                : <InfoBubbleNotesWrapper
                    label="Discussion on Understanding Risk and Reward:"
                    fieldKey={"understandingRiskAndReward"}
                    defaultValue={understandingRiskAndReward?.notes}
                    onBlur={(newValue) => updateRiskFactorNotes(understandingRiskAndReward.notesId, newValue)}
                />}
        </div>
        <div className="row mb-4">
            {isLoading
                ? <Skeleton />
                : <InfoBubbleNotesWrapper
                    label="Establishing Capacity for Loss:"
                    fieldKey={"capacityForLoss"}
                    defaultValue={capacityForLoss?.notes}
                    onBlur={(newValue) => updateRiskFactorNotes(capacityForLoss.notesId, newValue)}
                />}
        </div>
        <div className="row mb-4">
            {isLoading
                ? <Skeleton />
                : <InfoBubbleNotesWrapper
                    label="Understanding Risks of Pension Drawdown:"
                    fieldKey={"risksOfPensionDrawdown"}
                    defaultValue={risksOfPensionDrawdown?.notes}
                    onBlur={(newValue) => updateRiskFactorNotes(risksOfPensionDrawdown.notesId, newValue)}
                />}
        </div>
    </div>;
}

export default RiskFactorsSection;